import axios from 'axios';
import { API_BASE_URL } from './config';
import authHeader from './authHeader';

// Customer reservations / pré-commandes of out-of-stock products.
const reservationService = {
  // List reservations, optionally filtered by status (pending/arrived/delivered/cancelled).
  getReservations: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}reservations/`, {
      headers: authHeader(),
      params,
    });
    return response.data;
  },

  getReservation: async (id) => {
    const response = await axios.get(`${API_BASE_URL}reservations/${id}/`, {
      headers: authHeader(),
    });
    return response.data;
  },

  createReservation: async (data) => {
    const response = await axios.post(`${API_BASE_URL}reservations/`, data, {
      headers: authHeader(),
    });
    return response.data;
  },

  updateReservation: async (id, data) => {
    const response = await axios.patch(`${API_BASE_URL}reservations/${id}/`, data, {
      headers: authHeader(),
    });
    return response.data;
  },

  // Convenience: change only the status.
  setStatus: async (id, status) => {
    const response = await axios.patch(`${API_BASE_URL}reservations/${id}/`, { status }, {
      headers: authHeader(),
    });
    return response.data;
  },

  // Block (hold) the product for the client: deducts the reserved qty from stock
  // server-side and sets the reservation to "blocked".
  blockReservation: async (id) => {
    const response = await axios.post(`${API_BASE_URL}reservations/${id}/block/`, {}, {
      headers: authHeader(),
    });
    return response.data;
  },

  // Débloquer: reverse a block — gives the held qty back to stock and returns
  // the reservation to "arrived".
  unblockReservation: async (id) => {
    const response = await axios.post(`${API_BASE_URL}reservations/${id}/unblock/`, {}, {
      headers: authHeader(),
    });
    return response.data;
  },

  // Prepare selling a reserved product at the "Nouvelle vente" counter: releases
  // any hold (so the panier deducts stock once) and finds/creates the real client
  // so it can be preselected. Returns { reservation_id, customer_id, product_id, quantity }.
  prepareSale: async (id) => {
    const response = await axios.post(`${API_BASE_URL}reservations/${id}/prepare-sale/`, {}, {
      headers: authHeader(),
    });
    return response.data;
  },

  deleteReservation: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}reservations/${id}/`, {
      headers: authHeader(),
    });
    return response.data;
  },
};

export default reservationService;
